import { render, staticRenderFns } from "./TenantOverview.vue?vue&type=template&id=fad3df9c&scoped=true&"
import script from "./TenantOverview.vue?vue&type=script&lang=js&"
export * from "./TenantOverview.vue?vue&type=script&lang=js&"
import style0 from "./TenantOverview.vue?vue&type=style&index=0&id=fad3df9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fad3df9c",
  null
  
)

export default component.exports